<template>
<div>
    <div v-if="false" class="el-descriptions__title">Resumo Geral</div>
    <el-row v-if="false" :gutter="7">
        <el-col :span="8">
          <div class="statistic-card">
            <el-statistic :value="'1000'">
              <template #title>
                <div style="display: inline-flex; align-items: center">
                  Tarefas Cadastradas
                  <el-tooltip
                    effect="dark"
                    content="Total de tarefas cadastradas pela sua empresa desde a criação da sua conta!"
                    placement="top"
                  >
                    <el-icon style="margin-left: 4px" :size="12">
                      <Warning />
                    </el-icon>
                  </el-tooltip>
                </div>
              </template>
            </el-statistic>
            <!-- <div class="statistic-footer">
              <div class="footer-item">
                <span>than yesterday</span>
                <span class="green">
                  24%
                  <el-icon>
                    <CaretTop />
                  </el-icon>
                </span>
              </div>
            </div> -->
          </div>
        </el-col>
        <el-col :span="8">
          <div class="statistic-card">
            <el-statistic :value="'650'">
              <template #title>
                <div style="display: inline-flex; align-items: center">
                  Tarefas entregues
                  <el-tooltip
                    effect="dark"
                    content="Total de tarefas entregues pela sua empresa desde a criação da sua conta"
                    placement="top"
                  >
                    <el-icon style="margin-left: 4px" :size="12">
                      <Warning />
                    </el-icon>
                  </el-tooltip>
                </div>
              </template>
            </el-statistic>
            <!-- <div class="statistic-footer">
              <div class="footer-item">
                <span>month on month</span>
                <span class="red">
                  12%
                  <el-icon>
                    <CaretBottom />
                  </el-icon>
                </span>
              </div>
            </div> -->
          </div>
        </el-col>
        <el-col :span="8">
          <div class="statistic-card">
            <el-statistic :value="'65%'" title="New transactions today">
              <template #title>
                <div style="display: inline-flex; align-items: center">
                  Produtividade Geral
                  <el-tooltip
                    effect="dark"
                    content="Taxa de produtividade da sua empresa no geral"
                    placement="top"
                  >
                    <el-icon style="margin-left: 4px" :size="12">
                      <Warning />
                    </el-icon>
                  </el-tooltip>
                </div>
              </template>
            </el-statistic>
            <!-- <div class="statistic-footer">
              <div class="footer-item">
                <span>than yesterday</span>
                <span class="green">
                  16%
                  <el-icon>
                    <CaretTop />
                  </el-icon>
                </span>
              </div>
              <div class="footer-item">
                <el-icon :size="14">
                  <ArrowRight />
                </el-icon>
              </div>
            </div> -->
          </div>
        </el-col>
      </el-row>

    <el-descriptions
      class="margin-top"
      title="Dados Cadastrais"
      :column="3"
      :size="size"
      border
      v-loading="loading"
    >
    <template #extra>
    <el-button type="success" icon="Edit" @click="handleOpenDrawer()" plain>
        Atualizar Dados
    </el-button>
    </template>
    <el-descriptions-item>
      <template #label>
        <div class="cell-item">
          <el-icon>
            <office-building />
          </el-icon>
          Empresa
        </div>
      </template>
      {{  company.name }}
    </el-descriptions-item>
    <el-descriptions-item>
      <template #label>
        <div class="cell-item">
          <el-icon>            
            <PhoneFilled />
          </el-icon>
          Fone
        </div>
      </template>
      {{  company.phone }}
    </el-descriptions-item>
    <el-descriptions-item>
      <template #label>
        <div class="cell-item">
          <el-icon>
            <location />
          </el-icon>
          Cidade/UF
        </div>
      </template>
      {{  company.city }} / {{  company.state }}
    </el-descriptions-item>
    <el-descriptions-item>
      <template #label>
        <div class="cell-item">            
          <el-icon>
            <Message />
          </el-icon>
          E-mail
        </div>
      </template>
      {{  company.email }}
    </el-descriptions-item>
    <el-descriptions-item>
      <template #label>
        <div class="cell-item">
          <el-icon>
            <MapLocation />
          </el-icon>
          Endereço
        </div>
      </template>
      {{ company.street }} - {{ company.neighborhood }}
    </el-descriptions-item>
  </el-descriptions>

  <el-drawer v-model="drawer">
    <template #header>
      <h4>Atualize abaixos os dados da sua empresa</h4>
    </template>
    <template #default>
        <el-form label-position="top" :model="formCompany">

            <el-form-item label="Empresa">
                <el-input v-model="formCompany.name" />
            </el-form-item>
            <el-form-item label="CNPJ">
                <el-input v-model="formCompany.cnpj" v-mask="'##.###.###/####-##'" />
            </el-form-item>
            <el-form-item label="Fone">
                <el-input v-model="formCompany.phone" v-mask="'(##) #####-####'" />
            </el-form-item>
            <el-form-item label="E-mail">
                <el-input v-model="formCompany.email" />
            </el-form-item>
            <el-form-item label="CEP">
                <el-input v-model="formCompany.zipcode" v-mask="'##.###-###'" />
            </el-form-item>
            <el-form-item label="Endereço">
                <el-input v-model="formCompany.street" />
            </el-form-item>
            <el-form-item label="Bairro">
                <el-input v-model="formCompany.neighborhood" />
            </el-form-item>
            <el-form-item label="Cidade">
                <el-input v-model="formCompany.city" />
            </el-form-item>
            <el-form-item label="Estado">
                <el-input v-model="formCompany.state" />
            </el-form-item>

        </el-form>
    </template>
    <template #footer>
      <div style="flex: auto">
        <el-button @click="closeDrawer()">Fechar</el-button>
        <el-button type="primary" @click="handleSubmit()">Salvar</el-button>
      </div>
    </template>
  </el-drawer>
</div>
</template>
<script>
import { getCompany, updateCompany } from '@/services/companyService';
import { ElNotification } from 'element-plus';

export default {
    name: 'SettingsAccount',
    data() {
        return {
            drawer: false,
            company: {},
            formCompany: {},
            loading: false
        }
    },
    mounted(){
        this.getData();
    },
    methods: {
        async getData() {
            this.loading = true;
            
            try {
              const response = await getCompany();

              this.company = response.data;

              console.log('dados de company da api > ', this.company);
            } catch (error) {
              ElNotification({
                  title: 'Ops!',
                  message: 'Falha na requisição, atualize sua página e tente novamente!',
                  type: 'error'
              });
            } finally {
              this.loading = false;
            }

            this.loading = false;
        },
        handleOpenDrawer() {
            this.formCompany = this.company;

            this.drawer = true;
        },
        async handleSubmit() {
          this.loading = true;

          try {
            const response = await updateCompany(this.formCompany);
           
            console.log('dados atualizados ', response);
            
            this.getData();

            ElNotification({
              title: 'Atenção!',
              message: 'Registro salvo com sucesso.',
              type: 'success'
            });

          } catch (error) {
            ElNotification({
                title: 'Ops!',
                message: 'Falha na requisição, atualize sua página e tente novamente!',
                type: 'error'
            });
          } finally {
            this.drawer = false;
            this.loading = false;
          }

        },
        closeDrawer() {
            this.drawer = false;            
        }
    }
}
</script>

<style scoped>
:global(h2#card-usage ~ .example .example-showcase) {
  background-color: var(--el-fill-color) !important;
}

.el-statistic {
  --el-statistic-content-font-size: 28px;
}

.statistic-card {  
  padding: 20px;
  border-radius: 4px;
  background-color: var(--el-bg-color-overlay);
  margin: 10px 0;
}

.statistic-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  font-size: 12px;
  color: var(--el-text-color-regular);
  margin-top: 16px;
}

.statistic-footer .footer-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.statistic-footer .footer-item span:last-child {
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
}

.green {
  color: var(--el-color-success);
}
.red {
  color: var(--el-color-error);
}
</style>
